/* eslint-disable react/no-unused-state */
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/order
import React, { Component, Fragment } from 'react';
import Spinner from '../components/utils/Spinner';
import TopPanel from '../components/utils/TopPanel';
import '../styles/containers/Parties.css';
import TableSortingElem from '../infrastructure/TableSorting';
import TagFilterForm from '../components/forms/TagFilterForm';
import { generateKeyStr } from '../infrastructure/utils/common';
import * as Service from '../services/ActivitiesService';
import TagsList from '../components/tags/TagsList/TagsList';
import MobileTopPanelActions from '../components/utils/MobileTopPanelActions';
import MobileListSorter from '../components/utils/MobileListSorter';
import NewTagForm from '../components/forms/NewTagForm';

function sortByName(a, b) {
  const nameA = a.name.toLowerCase();
  const nameB = b.name.toLowerCase();
  if (nameA < nameB) {
    return -1;
  }
  if (nameA > nameB) {
    return 1;
  }
  return 0;
}

function reversSortByName(a, b) {
  const nameA = a.name.toLowerCase();
  const nameB = b.name.toLowerCase();
  if (nameA < nameB) {
    return 1;
  }
  if (nameA > nameB) {
    return -1;
  }
  return 0;
}

const initialState = {
  tagsLoaded: false,
  allTags: false,
  deactive: false,
  noData: false,
  activeSort: new TableSortingElem({ name: 'name', isString: true, up: true }),
  avaliableSort: [
    new TableSortingElem({ name: 'name', isString: true, up: true }),
    new TableSortingElem({ name: 'name', isString: true, up: false }),
  ],
  tags: null,
  token: undefined,
  filter: 'all',
  openModal: false,
  currentTag: { name: ' ', type: '' },
  firstLoad: true,
  isMobileFilterSelected: false,
  isMobileSortSelected: false,
  isCreateModalOpen: false,
};

export class Tags extends Component {
  constructor(props) {
    super(props);
    this.state = initialState;
  }

  async componentDidMount() {
    document.documentElement.style.overflow = 'hidden';
    await this.loadFirstTags();
  }

  componentWillUnmount() {
    document.documentElement.style.overflow = 'auto';
    this.setState({ deactive: true });
  }

  loadFirstTags = async () => {
    // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
    // @ts-ignore
    this.loadTags({ token: null, firstLoad: true });
  };

  handleTagClick = tag => {
    this.setState({ currentTag: tag });
  };

  handleSearchTagClick = selectedtag => {
    // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
    // @ts-ignore
    const { tags } = this.state;
    const currentTag = tags.find(tag => tag.name === selectedtag);
    this.setState({ currentTag });
  };

  searchTagsByName = async val => {
    // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
    // @ts-ignore
    const { searchedTags } = this.state;
    const searched = searchedTags.filter(tag => tag.name.indexOf(val) > -1);
    this.setState({ tags: searched });
  };

  loadTags = async ({ firstLoad }) => {
    const data = await Service.getAllTags();
    if (data === null) {
      this.setState({ tagsLoaded: true });
    } else {
      // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
      // @ts-ignore
      const { deactive } = this.state;
      if (!deactive) {
        if (firstLoad) {
          this.setState({
            tags: data.sort(sortByName),
            searchedTags: data,
            tagsLoaded: true,
          });
        } else {
          this.setState(state => ({
            // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
            // @ts-ignore
            parties: state.tags.concat(data.Items),
            token: data.LastEvaluatedKey,
            noData: false,
          }));
        }
      }
    }
  };

  sortTag = sort => {
    // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
    // @ts-ignore
    const { tags } = this.state;
    if (sort.name === 'name') {
      const sortedTags = sort.up
        ? tags.sort(sortByName)
        : tags.sort(reversSortByName);
      this.setState({ tags: sortedTags });
    }
  };

  getFilteredTags = filterData => {
    this.setState({ filterData, tags: this.filter(filterData) });
  };

  filter = filterData => {
    // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
    // @ts-ignore
    const { searchedTags } = this.state;
    let result = searchedTags;
    if (filterData.type.length > 0) {
      result = result.filter(elem => elem.type === filterData.type);
    }
    if (filterData.name.length > 0) {
      result = result.filter(
        elem =>
          elem.name.toLowerCase().indexOf(filterData.name.toLowerCase()) > -1
      );
    }
    return result;
  };

  changeSort = name => {
    // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
    // @ts-ignore
    const { activeSort, avaliableSort } = this.state;
    let sort = null;
    if (activeSort.name === name) {
      sort = {
        ...activeSort,
        up: !activeSort.up,
      };
      this.setState({ activeSort: sort });
    } else {
      sort = avaliableSort.find(s => s.name === name);
      this.setState({ activeSort: sort });
    }
    this.sortTag(sort);
  };

  changeSortBySelect = (name, up) => {
    // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
    // @ts-ignore
    const { avaliableSort, tags } = this.state;
    const sort = avaliableSort.find(s => s.name === name);
    if (!sort) return;
    const sortyCopy = { ...sort };
    sortyCopy.up = up;
    this.setState({ activeSort: sortyCopy });
    const sortedTags = sortyCopy.up
      ? tags.sort(sortByName)
      : tags.sort(reversSortByName);
    this.setState({ tags: sortedTags });
  };

  updateTag = async (tag, value) => {
    // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
    // @ts-ignore
    const { tags, searchedTags } = this.state;
    const el = tags.find(elem => elem.name === tag);
    const index = tags.indexOf(el);
    const searchedEl = searchedTags.find(elem => elem.name === tag);
    const searchedIndex = searchedTags.indexOf(searchedEl);
    const currentTag = {
      ...el,
      type: value,
    };
    tags[index] = currentTag;
    searchedTags[searchedIndex] = currentTag;
    await Service.updateTag(currentTag);
    this.setState(() => ({ tags: [...tags], searchedTags: [...searchedTags] }));
  };

  handleTagChange = ({ target }) => {
    this.setState(prevState => {
      const currentTag = {
        // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
        // @ts-ignore
        ...prevState.currentTag,
        type: target.value,
      };
      return { currentTag };
    });
  };

  render() {
    const {
      // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
      // @ts-ignore
      tagsLoaded,
      // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
      // @ts-ignore
      tags,
      // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
      // @ts-ignore
      activeSort,
      // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
      // @ts-ignore
      filterData,
      // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
      // @ts-ignore
      isMobileFilterSelected,
      // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
      // @ts-ignore
      isMobileSortSelected,
      // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
      // @ts-ignore
      avaliableSort,
      // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
      // @ts-ignore
      isCreateModalOpen,
    } = this.state;
    if (!tagsLoaded) {
      return <Spinner />;
    }
    return (
      <Fragment>
        <NewTagForm
          isOpen={isCreateModalOpen}
          closeModal={() => this.setState({ isCreateModalOpen: false })}
        />
        <TopPanel>
          <h1
            className='col-md-6 col-sm-4 col-xs-3'
            style={{ marginTop: '0px' }}
          >
            <span className='fas fa-beer' /> Tags
          </h1>
          {
            // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
            // @ts-ignore
            <MobileTopPanelActions
              isFilterSelected={isMobileFilterSelected}
              isSortSelected={isMobileSortSelected}
              onFilterClick={() =>
                this.setState({
                  isMobileFilterSelected: !isMobileFilterSelected,
                })
              }
              onSortClick={() =>
                this.setState({ isMobileSortSelected: !isMobileSortSelected })
              }
            />
          }
        </TopPanel>
        <div className='data-container'>
          <TagFilterForm
            // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
            // @ts-ignore
            filterTags={this.getFilteredTags}
            filterData={filterData}
            isMobileFilterSelected={isMobileFilterSelected}
          />
          <MobileListSorter
            isSortSelected={isMobileSortSelected}
            activeSort={activeSort}
            availableSort={avaliableSort}
            changeSortBySelect={this.changeSortBySelect}
          />
          <div className='clearfix' />
          <button
            className='btn btn-primary'
            type='button'
            onClick={() => this.setState({ isCreateModalOpen: true })}
          >
            Add new Tag
          </button>
          {tags.length > 0 ? (
            <div
              key={generateKeyStr()}
              className='table-box tab-cont small-height'
            >
              <TagsList
                // TODO: (fix build workaround) Need to be fixed next time when this code will be changed
                // @ts-ignore
                content={tags}
                activeSort={activeSort}
                changeSort={this.changeSort}
                handleTagChange={this.updateTag}
              />
            </div>
          ) : (
            <h2>Tags list is empty</h2>
          )}
        </div>
      </Fragment>
    );
  }
}
